<chart class="chart-dashboard" [options]="graphicOptions.options" (load)="setChart($event.context)"></chart>
